module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.421 25.814L21.611 16l9.814-9.814a1.977 1.977 0 0 0 0-2.803L28.618.58a1.984 1.984 0 0 0-2.803 0l-9.81 9.814L6.191.58a1.984 1.984 0 0 0-2.803 0L.585 3.387a1.977 1.977 0 0 0 0 2.803l9.814 9.814-9.814 9.81a1.977 1.977 0 0 0 0 2.803l2.803 2.803c.773.773 2.03.773 2.803 0l9.814-9.814 9.81 9.814c.773.773 2.03.773 2.803 0l2.803-2.803a1.97 1.97 0 0 0 0-2.803z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/x-1.js
// module id = 1505
// module chunks = 14